import React from 'react';
import { format, isAfter } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import {
  ExpiredMessageContainer,
  ExpiredMessageText,
  Info, InfoContainer, TextContainer, Title,
} from './styles';
import VirtualRaceSubscriptionCard from '../../components/VirtualRaceSubscriptionCard/index';
import { VirtualRaceType } from '../../types/VirtualRace';

interface Props {
  virtualRace:VirtualRaceType
}

export default function VirtualRaceSubscription({ virtualRace }: Props) {
  const startDate = virtualRace.startDate ? format(new Date(virtualRace.startDate), "d 'de' MMMM 'de' yyyy", { locale: ptBR }) : null;
  const endDate = virtualRace.endDate ? format(new Date(virtualRace.endDate), "d 'de' MMMM 'de' yyyy", { locale: ptBR }) : null;
  const isExpired = virtualRace.endDate && isAfter(new Date(), new Date(virtualRace.endDate));

  return (
    <>
      <InfoContainer>
        <Info>{virtualRace.description}</Info>
      </InfoContainer>
      <TextContainer>
        <Title>Como funciona o desafio?</Title>
        <Info>A Corrida Virtual vai sendo concluída a partir da soma das distâncias de suas atividades (corridas, caminhadas, pedaladas, natação, etc.).</Info>
        <Info>Você pode registrar as atividades direto na plataforma ou de forma automática, pelas integrações com relógios e outros aplicativos.</Info>
      </TextContainer>
      {virtualRace.type === 'DATE' && startDate && endDate && (
        <TextContainer>
          <Title>Período de Participação</Title>
          <Info>{`A corrida virtual estará disponível de ${startDate} até ${endDate}. Participe dentro desse período para conquistar sua medalha.`}</Info>
        </TextContainer>
      )}
      {isExpired ? (
        <ExpiredMessageContainer>
          <ExpiredMessageText>
            {`O período de inscrição para esta corrida virtual foi encerrado em ${endDate}.`}
          </ExpiredMessageText>
        </ExpiredMessageContainer>
      ) : (
        <VirtualRaceSubscriptionCard virtualRace={virtualRace} />
      )}
    </>
  );
}
